import _ from "lodash";
import { useI18n } from "vue-i18n";
import {
  COUNTRY_CODE,
  CALEDONIE_AGENCY_START_POSTAL_CODE,
} from "@/utils/localisation";

export const REFERENCIAL_NAME = {
  default: "DEFAULT",
};

export const COUNTRY_WITH_DIAGNOSTIC_REPORTS = [
  COUNTRY_CODE.france,
  COUNTRY_CODE.polynesie_française,
];

export const COUNTRY_WITH_RD_REPORTS = [
  COUNTRY_CODE.maroc,
  COUNTRY_CODE.luxembourg,
];

export const REFERENCIAL_APPLICATION_NAME = {
  CT_RAPSOTEC_FRANCE: "CT_RAPSOTEC_FRANCE",
  CT_RAPSOTEC_MAROC: "CT_RAPSOTEC_MAROC",
  SECU_RAPSOSECU_FRANCE: "SECU_RAPSOSECU_FRANCE",
  ITM_RAPSOITM_LUXEMBOURG: "ITM_RAPSOITM_LUXEMBOURG",
};

export const REFERENCIAL_NAME_BY_COUNTRY = {
  [COUNTRY_CODE.france]: REFERENCIAL_APPLICATION_NAME.CT_RAPSOTEC_FRANCE,
  [COUNTRY_CODE.maroc]: REFERENCIAL_APPLICATION_NAME.CT_RAPSOTEC_MAROC,
};

// INFO - AG - 27/07/2022 - Some French agencies, such as those in the TOM, do not have to display the questionnaire.
// Enter here the start of postal code of the agencies that do not need this feature.

export const FR_AGENCIES_WITH_NO_QUESTIONNAIRE = [
  CALEDONIE_AGENCY_START_POSTAL_CODE,
];

export const GRPC_PARAMS = {
  NATIONAL_CURRENT_RAPSOSECU_PARAMS: {
    versionName: "CURRENT",
    applicationName: REFERENCIAL_APPLICATION_NAME.SECU_RAPSOSECU_FRANCE,
    referencialType: "NATIONAL",
    referencialName: "DEFAULT",
  },
  NATIONAL_DRAFT_RAPSOSECU_PARAMS: {
    versionName: "DRAFT",
    applicationName: REFERENCIAL_APPLICATION_NAME.SECU_RAPSOSECU_FRANCE,
    referencialType: "NATIONAL",
    referencialName: "DEFAULT",
  },
  NATIONAL_CURRENT_RAPSOITM_PARAMS: {
    versionName: "CURRENT",
    applicationName: REFERENCIAL_APPLICATION_NAME.ITM_RAPSOITM_LUXEMBOURG,
    referencialType: "NATIONAL",
    referencialName: "DEFAULT",
  },
  NATIONAL_DRAFT_RAPSOITM_PARAMS: {
    versionName: "DRAFT",
    applicationName: REFERENCIAL_APPLICATION_NAME.ITM_RAPSOITM_LUXEMBOURG,
    referencialType: "NATIONAL",
    referencialName: "DEFAULT",
  },
  NATIONAL_CURRENT_PARAMS: {
    versionName: "CURRENT",
    applicationName: REFERENCIAL_APPLICATION_NAME.CT_RAPSOTEC_FRANCE,
    referencialType: "NATIONAL",
    referencialName: "DEFAULT",
  },
  MOROCCO_CURRENT_PARAMS: {
    versionName: "CURRENT",
    applicationName: REFERENCIAL_APPLICATION_NAME.CT_RAPSOTEC_MAROC,
    referencialType: "NATIONAL",
    referencialName: "DEFAULT",
  },
  NATIONAL_DRAFT_PARAMS: {
    versionName: "DRAFT",
    applicationName: REFERENCIAL_APPLICATION_NAME.CT_RAPSOTEC_FRANCE,
    referencialType: "NATIONAL",
    referencialName: "DEFAULT",
  },
  MOROCCO_DRAFT_PARAMS: {
    versionName: "DRAFT",
    applicationName: REFERENCIAL_APPLICATION_NAME.CT_RAPSOTEC_MAROC,
    referencialType: "NATIONAL",
    referencialName: "DEFAULT",
  },
};

export const REFERENTIAL_FILTERS = {
  TOUT: "TOUT",
  ASO: "ASO",
  RPP: "RPP",
  RVRAT: "RVRAT",
  FSD: "FSD",
  SD: "SD",
  PA: "PA",
  AR: "AR",
  BIB: "BIB",
  PAT: "PAT",
  PM: "PM",
  PT: "PT",
};

// traduction with i18n message in SocioReferencialLegend
export const REFERENCIAL_HEADERS = () => {
  const { t } = useI18n();
  return {
    RPP: t("rpp"),
    ASO: t("aso"),
    ARTREGL: t("rules"),
    ACTIONS: t("actions"),
    BIBLIO: t("biblio"),
  };
};

export const levels = _.range(1, 8);

export const REFERENCIAL_VERSION = {
  current: "CURRENT",
  draft: "DRAFT",
};

// INFO - Léo Hauhcecorne - 06/01/2023 - Some features should be enabled only for specific codes.

// section_code 20 = Sécurité incendie (DSE, DSH, DST, ENV)
// section_code 33 = Handicap (HAND, HANDCO)
export const SECTION_CODES_QUICK_TOPIC_CREATION = new Set([20, 33]);

export const SERVICE_NAME = {
  RAPSOSECU: "RAPSOSECU",
  RAPSOTEC: "RAPSOTEC",
};
